export enum BasePosition {
  START = "Start",
  CENTER = "Center",
  END = "End",
  STRETCH = "Stretch"
}

export enum DialogPosition {
  LEFT = "left",
  LEFT_START = "left-start",
  LEFT_END = "left-end",
  RIGHT = "right",
  RIGHT_START = "right-start",
  RIGHT_END = "right-end",
  TOP = "top",
  TOP_START = "top-start",
  TOP_END = "top-end",
  BOTTOM = "bottom",
  BOTTOM_START = "bottom-start",
  BOTTOM_END = "bottom-end"
}
